module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Download-b6bdfb5da2c3c45ea65ae8f2ea22da31.svg";